import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as PR from "../../../../prime-react/index";
import { useDispatch, useSelector } from "react-redux";
import { filterOptionsActions } from "../../../../store/FiltersOptions";
import { getSearchOptions } from "../../../../services/api";
const SummarySearchFilter = ({
  setFilters,
  staticOptionData,
  setFilterDialogVisible,
  selectedFilters,
  groupId,
  requestType
}) => {
  const dispatch = useDispatch();
  const sessionData = useSelector((state) => state.auth.sessionData);
  const storedFilterOptions = useSelector((state) => state.filterOptions);

  const headers = useMemo(() => {
    return { sessionid: sessionData.sessionId };
  }, [sessionData.sessionId]);

  const role = sessionData?.role;
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [events, setEvents] = useState([]);
  const [eventSearch, setEventSearch] = useState("");
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [checkedEvents, setCheckedEvents] = useState({});
  const getSelectedEvents = () => {
    return events?.filter((item) => checkedEvents[item.id]);
  };
  const [sports, setSports] = useState([]);
  const [sportSearch, setSportSearch] = useState("");
  const [filteredSports, setFilteredSports] = useState([]);
  const [checkedSports, setCheckedSports] = useState({});

  const getSelectedSports = () => {
    return sports?.filter((item) => checkedSports[item.id]);
  };
  const isAnySportSelected = Object.values(checkedSports).some((val) => val);

  const [tournaments, setTournaments] = useState([]);
  const [tournamentSearch, setTournamentSearch] = useState("");
  const [filteredTournaments, setFilteredTournaments] = useState([]);
  const [checkedTournaments, setCheckedTournaments] = useState({});

  const getSelectedTournaments = () => {
    return tournaments?.filter((item) => checkedTournaments[item.id]);
  };

//  const [playerSearchValues, setPlayerSearchValues] = useState([]); // for display in <Chips />
  const [checkedPlayers, setCheckedPlayers] = useState([]);

/* const handlePlayerChipsChange = (e) => {
  const chipStrings = e.value || [];
  // Update display with truncation (max 10 chars + "...")
  const truncatedDisplay = chipStrings.map((val) =>
    val.length > 10 ? val.slice(0, 10) + "..." : val
  );
  setPlayerSearchValues(truncatedDisplay);
  // Convert to array of objects
  const playerObjects = chipStrings.map((val) => ({
    id: val,
    name: val
  }));
  setCheckedPlayers(playerObjects);
}; */

  const [date, setDate] = useState([new Date(), new Date()]);
  const [dateRange, setDateRange] = useState("");

  const [locations, setLocations] = useState([]);
  const [locationSearch, setLocationSearch] = useState("");
  const [filteredLocations, setFilteredLocations] = useState([]);
  const [checkedLocations, setCheckedLocations] = useState({});

  const getSelectedLocations = () => {
    return locations?.filter((item) => checkedLocations[item.id]);
  };

  const [channels, setChannels] = useState([]);
  const [checkedChannels, setCheckedChannels] = useState({});

  const getSelectedChannels = () => {
    return channels?.filter((item) => checkedChannels[item.id]);
  };
  const [betNames, setBetNames] = useState([]);
  const [filterBetNames, setFilterBetNames] = useState([]);
  const [checkedBetNames, setCheckedBetNames] = useState({});

  const getSelectedBetNames = () => {
    return betNames?.filter((item) => checkedBetNames[item.id]);
  };
  const handleTypeSpecificSetters = useCallback((type, options) => {
    const setterMap = {
      sport: [setSports, setFilteredSports],
      event: [setEvents, setEvents],
      tournament: [setTournaments, setTournaments],
      property: [setLocations, setFilteredLocations],
      bet_type: [setBetNames, setBetNames]
    };
  
    if (setterMap[type]) {
      setterMap[type].forEach(setter => setter(options || []));
      if(type === 'event' && initialLoad){
        handleSearch( { target: { value: selectedFilters?.eventSearch ?? '' } }, setEventSearch, options, setFilteredEvents, 'event'  ) 
      }
      if(type === 'tournament' && initialLoad){
        handleSearch( { target: { value: selectedFilters?.tournamentSearch ?? ''} }, setTournamentSearch, options, setFilteredTournaments, 'tournament' )
      }
    }
  }, [selectedFilters?.eventSearch, selectedFilters?.tournamentSearch, initialLoad]);
  const getSearchOptionsHandler = useCallback(() => {
    const getResponse = (type) => (response) => {
      setLoading(false);
      if (response.result === "SUCCESS") {
        const filterOptionData = response.data?.length
          ? response.data.map((r) => ({ id: r.id, name: r.name })).sort((a, b) => a.name.localeCompare(b.name)).filter(r => r.name?.toLowerCase() !=='unknown')
          : [];
        handleTypeSpecificSetters(type, filterOptionData);
        dispatch(filterOptionsActions.storeFilterOptions({key: type , options: filterOptionData}))
      }
    };
    const types = ["sport", "property", "bet_type"];
    types.forEach((type) => {
      if (storedFilterOptions[type]?.length === 0) {
        setLoading(true);
        let queryParam = '';
        if(type === 'property'){
           queryParam =`groups[]=${groupId}`;
        }
        getSearchOptions(type, headers, dispatch, getResponse(type), queryParam);
      } else {
        handleTypeSpecificSetters(type, storedFilterOptions[type]);
      }
    });
    setChannels(staticOptionData?.newchannels);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, headers, staticOptionData?.newchannels]);

   useEffect(() => {
    const sportList = sports?.filter((item) => checkedSports[item.id]);
    const sportIDs = sportList?.map((sport) => sport.id).map(id => `sports[]=${id}`).join('&');
    if (sportIDs) {
      const typesToFetch = ["event", "tournament"];
      typesToFetch.forEach((type) => {
        getSearchOptions(type, headers, dispatch, (response) => {
          if (response.result === "SUCCESS") {
            const options = response.data?.map((r) => ({
              id: type === 'event' ? r.name : r.id,
              name: r.name,
              sportID: r.sportID
            })).sort((a, b) => a.name.localeCompare(b.name)).filter(r => r.name?.toLowerCase() !=='unknown') || [];
            handleTypeSpecificSetters(type, options);
            dispatch( filterOptionsActions.storeFilterOptions({ key: type, options, }) );
          }
        }, sportIDs); // Pass sportID in params
      });
    } else {
      // No sport selected – clear everything
      setFilteredTournaments([]);
      setCheckedTournaments({});
      setCheckedEvents({});
      setFilteredEvents([]);
    }
  }, [checkedSports, headers, dispatch, sports, handleTypeSpecificSetters]);
  
  useEffect(() => {
    getSearchOptionsHandler();
  }, [getSearchOptionsHandler]);

  useEffect(() => {
    selectedFilters?.events?.forEach(({ id }) => {
      setCheckedEvents((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });
    selectedFilters?.sports?.forEach(({ id }) => {
      setCheckedSports((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });
    selectedFilters?.tournaments?.forEach(({ id }) => {
      setCheckedTournaments((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });
    selectedFilters?.players?.forEach(({ id }) => {
      setCheckedPlayers(selectedFilters.players);
     // setPlayerSearchValues(selectedFilters.players.map((p) => p.name));
    });
    selectedFilters?.locations?.forEach(({ id }) => {
      setCheckedLocations((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });
    selectedFilters?.betNames?.forEach(({ id }) => {
      setCheckedBetNames((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });
    selectedFilters?.channel?.forEach(({ id }) => {
      setCheckedChannels((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });

    if (selectedFilters?.date?.date?.length) {
      setDate(selectedFilters?.date?.date);
    }
    if (selectedFilters?.date?.dateRange) {
      setDateRange(selectedFilters?.date?.dateRange);
    }
    setEventSearch(selectedFilters?.eventSearch ?? '');
    setTournamentSearch(selectedFilters?.tournamentSearch ?? '')
    setInitialLoad(true);
  }, [selectedFilters]);

  // bet type filter options enable or disable
  useEffect(() => {
    let betNameFilters = betNames;
    if (requestType === 'single') {
      betNameFilters = betNames.filter(b => b.name.toLowerCase() === 'single')
    } else if (requestType === 'parlay') {
      const options = ['combo', 'parlay', 'progressive parlay'];
      betNameFilters = betNames.filter(b => options.includes(b.name.toLowerCase()))
    }
    setFilterBetNames(betNameFilters);
  }, [betNames, requestType]);
  const formattedDate = (dateVal) => {
    if (dateVal === undefined || dateVal.length === 0) {
      return [];
    } else if (dateVal[1] === null && dateVal[0] !== null) {
      return [dateVal[0], dateVal[0]];
    } else if (dateVal[1] !== null && dateVal[0] !== null) {
      return dateVal;
    }
    return [];
  };

  const applyFilters = () => {
    const global = {
      events: getSelectedEvents(),
      sports: getSelectedSports(),
      tournaments: getSelectedTournaments(),
      players: checkedPlayers,
      date: { date: dateRange ? formattedDate(date) : "", dateRange },
      locations: getSelectedLocations(),
      channel: getSelectedChannels(),
      betNames: getSelectedBetNames(),
      eventSearch: eventSearch,
      tournamentSearch: tournamentSearch
    };
    setFilters(global);
    setFilterDialogVisible(false);
  };
  const tabChangeHandler = (index) => {
    setActiveIndex(index);
  };
  const resetFilters = () => {
    setCheckedEvents({});
    setCheckedSports({});
    setCheckedTournaments({});
    setCheckedPlayers([]);
    // setPlayerSearchValues([])
    setCheckedChannels({});
    setCheckedLocations({});
    setDate([new Date(), new Date()]);
    setDateRange("");
    setCheckedBetNames({});
  };
  const removeEventsAndTournaments = ({ id }) => {
    const updateCheckedItems = (items, checkedItems, setter, type = '') => {
      let selectedIds = Object.keys(checkedItems);
      if (type) {
        selectedIds = selectedIds.map(id => +id);
      }
      if (!selectedIds.length) return;

      const filteredItems = items
        .filter(item => selectedIds.includes(item.id) && item.sportID !== id)
        .reduce((acc, item) => {
          acc[item.id] = true;
          return acc;
        }, {});
      setter(filteredItems);
    };
    updateCheckedItems(events, checkedEvents, setCheckedEvents);
    updateCheckedItems(tournaments, checkedTournaments, setCheckedTournaments, 'tournaments');
  };

  const handleRemoveListFilter = (item, setter, type) => {
    setter((prevState) => {
      const updatedCheckedItems = { ...prevState };
      delete updatedCheckedItems[item.id];
      return updatedCheckedItems;
      /*   if (Array.isArray(prevState)) {
          // For chip-based filters (like players)
          const updatedArray = prevState.filter((p) => p.id !== item.id);
          // Also update the chip display
          if (type === "Player") {
            setPlayerSearchValues(updatedArray.map((p) => p.name));
          }
          return updatedArray;
        }  */
    });
    if (type === 'sport') {
      removeEventsAndTournaments({ id: item.id, checked: false })
    }
  };
  
  // const handleRemoveItemFilter = (type) => {
  //   setDateRange("");
  //   setDate([new Date(), new Date()]);
  // };
  const handleCheckboxChange = (setter, type) => (e) => {
    const { value, checked } = e.target;
    if(type){
      setInitialLoad(false)
    }
    if(!checked && type){
      removeEventsAndTournaments({ id: value})
    }
    setter((prevState) => ({
      ...prevState,
      [value]: checked,
    }));
  };
  const handleSearch = (event, setSearch, dataList, setFilteredData, type = '') => {
    const searchedValue = event.target.value;
    setSearch(searchedValue);
    const filteredData =
      dataList &&
      dataList.filter((item) =>
        item.name.toLowerCase().includes(searchedValue.toLowerCase())
      );
    if(type && searchedValue.length >= 3){
        setFilteredData(filteredData);
    } else if(type && !searchedValue){
        setFilteredData([]);
    } else if(!type) {
        setFilteredData(filteredData);
    }
  };
  const buttonSection = () => {
    return (
      <div className="flex flex-wrap justify-content-end gap-3 border-top">
        <PR.Button
          label="Reset Filters"
          outlined
          autoFocus
          className="logout-btns reset-btn"
          onClick={resetFilters}
        />
        <PR.Button
          label="Cancel"
          onClick={() => setFilterDialogVisible(false)}
          outlined
          className="logout-btns"
        />
        <PR.Button
          label="Apply Filters"
          outlined
          autoFocus
          className={
            role === "analyst"
              ? "logout-btns click-btn color-update"
              : "logout-btns click-btn"
          }
          onClick={applyFilters}
        />
      </div>
    );
  };

  const FiltersList = ({ items, label, setter, type }) => {
    if (!items?.length) return null;
    return (
      <div className={`filters-list mb-3 ${label === 'Property' || label === 'Bet Type' ? 'textTransform' : ''}`}>
        <ul>
          <li className="block">{label}: </li>
          {items.map((item, index) => (
            <li key={index}>
              <span>
                {item.name}{" "}
                <i
                  className="pi pi-times"
                  onClick={() => handleRemoveListFilter(item, setter, type)}
                ></i>
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  };
/*   const FilterItem = ({ label, value, handleRemove }) => {
    if (!value) return null;
    return (
      <div className="filters-list mb-3">
        <ul>
          <li className="block">{label}: </li>
          <li>
            <span>
              {value}
              <i className="pi pi-times" onClick={handleRemove}></i>
            </span>
          </li>
        </ul>
      </div>
    );
  }; */

  return (
    <>
      <div className="filter-dialog-body-section">
        <div className="grid grid-nogutter">
          <div className="col-9">
            <PR.TabView
              activeIndex={activeIndex}
              onTabChange={(e) => tabChangeHandler(e.index)}
            >
            <PR.TabPanel header="Sports">
              <div className="flex filter-options-section">
                <div className="flex align-items-center w-12 mb-2 sticky-search">
                  <span className="p-input-icon-left w-12">
                    <i className="pi pi-search" />
                    <PR.InputText
                      id="sportSearch"
                      placeholder="Search"
                      className="search-box"
                      value={sportSearch}
                      autoComplete="off"
                      onChange={(event) =>
                        handleSearch(
                          event,
                          setSportSearch,
                          sports,
                          setFilteredSports
                        )
                      }
                    />
                  </span>
                  <span className="search-clear-icon">
                    {!!sportSearch && (
                      <i
                        style={{ cursor: "pointer", color: "#6c757d" }}
                        onClick={() =>
                          handleSearch(
                            { target: { value: "" } },
                            setSportSearch,
                            sports,
                            setFilteredSports
                          )
                        }
                        className="pi pi-times text-sm mr-2"
                      />
                    )}
                  </span>
                </div>
                <div className="filters-list">
                  <div className="flex flex-wrap gap-3">
                    {loading ? (
                      <div className="filter-loading">
                        <i className="pi pi-spin pi-spinner"></i> Loading..
                      </div>
                    ) : (
                      <>
                        {filteredSports &&
                          filteredSports.map((sport, index) => (
                            <div
                              className="flex align-items-center status-box"
                              key={index}
                            >
                              <PR.Checkbox
                                inputId={sport.id}
                                value={sport.id}
                                onChange={handleCheckboxChange(
                                  setCheckedSports, 'sport'
                                )}
                                checked={checkedSports[sport.id]}
                              ></PR.Checkbox>
                              <label
                                htmlFor={sport.id}
                                className="ml-2 font-medium"
                              >
                                {sport.name}
                              </label>
                            </div>
                          ))}
                      </>
                    )}
                  </div>
                </div>
                {buttonSection()}
              </div>
            </PR.TabPanel>
              <PR.TabPanel header="Events" disabled={!isAnySportSelected}>
                <div className="flex filter-options-section">
                  <div className="flex align-items-center w-12 mb-2 sticky-search">
                    <span className="p-input-icon-left w-12">
                      <i className="pi pi-search" />
                      <PR.InputText
                        id="eventSearch"
                        placeholder="Enter an event name with atleast 3 characters"
                        className="search-box"
                        value={eventSearch}
                        autoComplete="off"
                        onChange={(event) => handleSearch( event, setEventSearch, events, setFilteredEvents, 'event' ) }
                      />
                    </span>
                    <span className="search-clear-icon">
                      {!!eventSearch && (
                        <i
                          style={{ cursor: "pointer", color: "#6c757d" }}
                          onClick={() => handleSearch( { target: { value: "" } }, setEventSearch, events, setFilteredEvents, 'event'  ) }
                          className="pi pi-times text-sm mr-2"
                        />
                      )}
                    </span>
                  </div>
                  <div className="filters-list">
                    <div className="flex flex-wrap gap-3">
                      {loading ? (
                        <div className="filter-loading">
                          <i className="pi pi-spin pi-spinner"></i> Loading..
                        </div>
                      ) : (
                        <>
                          {filteredEvents &&
                            filteredEvents.map((event, index) => (
                              <div
                                className="flex align-items-center status-box"
                                key={index}
                              >
                                <PR.Checkbox
                                  inputId={index+event.id}
                                  value={event.id}
                                  onChange={handleCheckboxChange(
                                    setCheckedEvents
                                  )}
                                  checked={checkedEvents[event.id]}
                                ></PR.Checkbox>
                                <label
                                  htmlFor={index+event.id}
                                  className="ml-2 font-medium"
                                >
                                  {event.name}
                                </label>
                              </div>
                            ))}
                        </>
                      )}
                    </div>
                  </div>
                  {buttonSection()}
                </div>
              </PR.TabPanel>
              <PR.TabPanel header="Tournament / League" disabled={!isAnySportSelected}>
                <div className="flex filter-options-section">
                  <div className="flex align-items-center w-12 mb-2 sticky-search">
                    <span className="p-input-icon-left w-12">
                      <i className="pi pi-search" />
                      <PR.InputText
                        id="tournamentSearch"
                        placeholder="Enter Tournament / League name with atleast 3 characters"
                        className="search-box"
                        value={tournamentSearch}
                        autoComplete="off"
                        onChange={(event) => handleSearch( event, setTournamentSearch, tournaments, setFilteredTournaments, 'tournament') }
                      />
                    </span>
                    <span className="search-clear-icon">
                      {!!tournamentSearch && (
                        <i
                          style={{ cursor: "pointer", color: "#6c757d" }}
                          onClick={() => handleSearch( { target: { value: "" } }, setTournamentSearch, tournaments, setFilteredTournaments, 'tournament' ) }
                          className="pi pi-times text-sm mr-2"
                        />
                      )}
                    </span>
                  </div>
                  <div className="filters-list">
                    <div className="flex flex-wrap gap-3">
                      {loading ? (
                        <div className="filter-loading">
                          <i className="pi pi-spin pi-spinner"></i> Loading..
                        </div>
                      ) : (
                        <>
                          {filteredTournaments &&
                            filteredTournaments.map((tournment, index) => (
                              <div
                                className="flex align-items-center status-box"
                                key={index}
                              >
                                <PR.Checkbox
                                  inputId={tournment.id}
                                  value={tournment.id}
                                  onChange={handleCheckboxChange(
                                    setCheckedTournaments
                                  )}
                                  checked={checkedTournaments[tournment.id]}
                                ></PR.Checkbox>
                                <label
                                  htmlFor={tournment.id}
                                  className="ml-2 font-medium"
                                >
                                  {tournment.name}
                                </label>
                              </div>
                            ))}
                        </>
                      )}
                    </div>
                  </div>
                  {buttonSection()}
                </div>
              </PR.TabPanel>
              {/* <PR.TabPanel header="Player">
                <div className="flex filter-options-section">
                  <div className="flex align-items-center w-12 mb-2 sticky-search">
                    <span className="p-input-icon-left w-12">
                      <PR.Chips
                        id="playerSearch"
                        value={playerSearchValues}
                        onChange={handlePlayerChipsChange}
                        separator=","
                        allowDuplicate={false}
                        className="player-chips"
                        placeholder="Enter Player ID's"
                      />
                    </span>
                  </div>
                  <div className="filters-list player-filters-list">
                    <div className="flex flex-wrap gap-3">
                    </div>
                  </div>
                  {buttonSection()}
                </div>
              </PR.TabPanel> */}
              {/* <PR.TabPanel header="Date">
                <div className="filter-options-section">
                  <div className="card date-calendar flex justify-content-center">
                    <PR.Calendar
                      name="date"
                      value={date}
                      inputId="searchDate"
                      onChange={handleDateRange}
                      inline
                      selectionMode="range"
                      maxDate={maxDate}
                    />
                  </div>
                  {buttonSection()}
                </div>
              </PR.TabPanel> */}
              <PR.TabPanel header="Property">
                <div className="flex filter-options-section">
                  <div className="flex align-items-center w-12 mb-2 sticky-search">
                    <span className="p-input-icon-left w-12">
                      <i className="pi pi-search" />
                      <PR.InputText
                        id="locationSearch"
                        placeholder="Search"
                        className="search-box"
                        value={locationSearch}
                        autoComplete="off"
                        onChange={(event) =>
                          handleSearch(
                            event,
                            setLocationSearch,
                            locations,
                            setFilteredLocations
                          )
                        }
                      />
                    </span>
                    <span className="search-clear-icon">
                      {!!locationSearch && (
                        <i
                          style={{ cursor: "pointer", color: "#6c757d" }}
                          onClick={() =>
                            handleSearch(
                              { target: { value: "" } },
                              setLocationSearch,
                              locations,
                              setFilteredLocations
                            )
                          }
                          className="pi pi-times text-sm mr-2"
                        />
                      )}
                    </span>
                  </div>
                  <div className="filters-list">
                    <div className="flex flex-wrap gap-3">
                      {loading ? (
                        <div className="filter-loading">
                          <i className="pi pi-spin pi-spinner"></i> Loading..
                        </div>
                      ) : (
                        <>
                          {filteredLocations &&
                            filteredLocations.map((location, index) => (
                              <div
                                className="flex align-items-center status-box textTransform"
                                key={index}
                              >
                                <PR.Checkbox
                                  inputId={location.id}
                                  value={location.id}
                                  onChange={handleCheckboxChange(
                                    setCheckedLocations
                                  )}
                                  checked={checkedLocations[location.id]}
                                ></PR.Checkbox>
                                <label
                                  htmlFor={location.id}
                                  className="ml-2 font-medium"
                                >
                                  {location.name}
                                </label>
                              </div>
                            ))}
                        </>
                      )}
                    </div>
                  </div>
                  {buttonSection()}
                </div>
              </PR.TabPanel>

               {/* <PR.TabPanel header="Channel">
                <div className="flex filter-options-section channel-section">
                  <div className="filters-list">
                    <div className="flex flex-wrap gap-3">
                      <>
                        {channels &&
                          channels.map((channel, index) => (
                            <div
                              className="flex align-items-center status-box"
                              key={index}
                            >
                              <PR.Checkbox
                                inputId={channel.id}
                                value={channel.id}
                                onChange={handleCheckboxChange(
                                  setCheckedChannels
                                )}
                                checked={checkedChannels[channel.id]}
                              ></PR.Checkbox>
                              <label
                                htmlFor={channel.id}
                                className="ml-2 font-medium"
                              >
                                {channel.name}
                              </label>
                            </div>
                          ))}
                      </>
                    </div>
                  </div>
                  {buttonSection()}
                </div>
              </PR.TabPanel> */}

              <PR.TabPanel header="Bet Type">
                <div className="flex filter-options-section channel-section">
                  <div className="filters-list">
                    <div className="flex flex-wrap gap-3">
                      <>
                        {filterBetNames &&
                          filterBetNames.map((ch, index) => (
                            <div
                              className="flex align-items-center status-box textTransform"
                              key={index}
                            >
                              <PR.Checkbox
                                inputId={ch.id}
                                value={ch.id}
                                onChange={handleCheckboxChange(
                                  setCheckedBetNames
                                )}
                                checked={checkedBetNames[ch.id]}
                              ></PR.Checkbox>
                              <label
                                htmlFor={ch.id}
                                className="ml-2 font-medium"
                              >
                                {ch.name}
                              </label>
                            </div>
                          ))}
                      </>
                    </div>
                  </div>
                  {buttonSection()}
                </div>
              </PR.TabPanel>
             
            </PR.TabView>
          </div>
          <div className="col-3 right-section">
            <p className="filters_p">Selected Filters:</p>
            <FiltersList
              items={getSelectedSports()}
              label="Sports"
              setter={setCheckedSports}
              type="sport"
            />
            <FiltersList
              items={getSelectedEvents()}
              label="Events"
              setter={setCheckedEvents}
            />
            <FiltersList
              items={getSelectedTournaments()}
              label="Tournament / League"
              setter={setCheckedTournaments}
            />
            <FiltersList
              items={checkedPlayers}
              label="Player"
              type="Player"
              setter={setCheckedPlayers}
            />
            {/* <FilterItem
              label="Date"
              value={dateRange}
              handleRemove={() => handleRemoveItemFilter("date")}
            /> */}
            <FiltersList
              items={getSelectedLocations()}
              label="Property"
              setter={setCheckedLocations}
            />
            {/* <FiltersList
              items={getSelectedChannels()}
              label="Channel"
              type="Channel"
              setter={setCheckedChannels}
            /> */}
            <FiltersList
              items={getSelectedBetNames()}
              label="Bet Type"
              setter={setCheckedBetNames}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SummarySearchFilter;
